import {
  MessageData,
  PeopleListData,
  TranscriptData,
  CallsLogData,
  VariableData,
  FaxMessage,
} from '@dataTypes/message.types'

export const MockDataMessages: MessageData[] = [
  {
    id: 1,
    imageSrc: './girl.png',
    name: 'Alex Smith',
    conversation: [
      {
        sender: 'Client',
        message: 'Hi! Can you tell more about your services?',
        timestamp: new Date('September 24, 2024 15:47:00').toISOString(),
      },
    ],
    isRead: false,
    channel: 'SMS',
  },
  {
    id: 2,
    imageSrc: './girl.png',
    name: 'Jane Smith',
    conversation: [
      {
        sender: 'Client',
        message:
          'Hi! I wanted to chec the time for my appointment on Thursday.',
        timestamp: new Date('September 24, 2024 14:47:00').toISOString(),
      },
    ],
    isRead: false,
    channel: 'Facebook',
    lastActive: '5 mins ago',
  },
  {
    id: 3,
    imageSrc: './boy.png',
    name: 'Fred Smith',
    conversation: [
      {
        sender: 'Client',
        message:
          'Hi! I’d like to raise my concern about my previous visit on your clinic',
        timestamp: new Date('September 23, 2024 17:25:00').toISOString(),
      },
      {
        sender: 'Clinic',
        message: `Oh, I’m sorry about that. We can talk about this matter. 
          May I know when is the best time to call you?`,
        timestamp: new Date('September 23, 2024 17:25:00').toISOString(),
      },
    ],
    isRead: true,
    channel: 'Instagram',
    lastActive: '30 mins ago',
  },
  {
    id: 4,
    imageSrc: './boy.png',
    name: 'John Smith',
    conversation: [
      {
        sender: 'Client',
        message: 'Hi! Can you tell more about your services?',
        timestamp: new Date('August 10, 2024 14:32:00').toISOString(),
      },
      {
        sender: 'Clinic',
        message:
          "Hi, John Smith! Thank you for reaching out. We'll get back to you on that.",
        timestamp: new Date('August 10, 2024 14:35:00').toISOString(),
      },
      {
        sender: 'Client',
        message: '{isCompletedCall}=/MockData-10-5.wav',
        timestamp: new Date('September 10, 2024 14:32:00').toISOString(),
      },
      {
        sender: 'Clinic',
        message:
          'Hello. I would like to remind you about your appointment this coming Tuesday.',
        timestamp: new Date('September 15, 2024 14:32:05').toISOString(),
      },
      {
        sender: 'Client',
        message: 'Hi, thanks for the reminder.',
        timestamp: new Date('September 15, 2024 14:32:05').toISOString(),
      },
    ],
    isRead: true,
    channel: 'SMS',
  },
  {
    id: 5,
    imageSrc: './girl.png',
    name: 'Alex Smith',
    conversation: [
      {
        sender: 'Client',
        message: 'Hi! Can you tell more about your services?',
        timestamp: new Date('August 10, 2023 14:32:00').toISOString(),
      },
      {
        sender: 'Clinic',
        message: 'Thank you for your interest with our clinic.',
        timestamp: new Date('August 10, 2023 14:32:02').toISOString(),
      },
      {
        sender: 'Clinic',
        message: 'Have a nice day!',
        timestamp: new Date('August 10, 2023 14:32:03').toISOString(),
      },
    ],
    isRead: true,
    channel: 'Messenger',
    lastActive: '15 mins ago',
  },
  {
    id: 6,
    imageSrc: '',
    name: 'Patrice S. Dumper',
    contact: '(949) 228-9834',
    conversation: [
      {
        sender: 'Client',
        message: 'Hi! Can you tell more about your services?',
        timestamp: new Date('August 10, 2023 14:32:00').toISOString(),
      },
    ],
    isRead: true,
    channel: 'SMS',
  },
  {
    id: 7,
    imageSrc: './girl.png',
    name: 'Alexandra Smith',
    conversation: [
      {
        sender: 'Client',
        message: 'Hi! Can you tell more about your services?',
        timestamp: new Date('August 10, 2023 14:32:00').toISOString(),
      },
    ],
    isRead: true,
    channel: 'Messenger',
    lastActive: '23 mins ago',
  },
  {
    id: 8,
    imageSrc: './girl.png',
    name: 'Alex Doe',
    conversation: [
      {
        sender: 'Client',
        message: 'Hi! Can you tell more about your services?',
        timestamp: new Date('August 10, 2023 14:32:00').toISOString(),
      },
    ],
    isRead: true,
    channel: 'Messenger',
    lastActive: '1 min ago',
  },
  {
    id: 9,
    imageSrc: './girl.png',
    name: 'Jane Doe',
    conversation: [
      {
        sender: 'Client',
        message: 'Hi! Can you tell more about your services?',
        timestamp: new Date('August 10, 2023 14:32:00').toISOString(),
      },
    ],
    isRead: true,
    channel: 'Instagram',
    lastActive: 'now',
  },
]

export const AIResponse = {
  response: `Here are the list of services that XYZ Clinic offers:
    \n-General Dentistry\n-Endodonics\n-Orthodontics\n-Dental Radiography\n-Oral Surgery`,
}

export const VariableList: VariableData[] = [
  {
    text: '(clinic_name)',
    value: 'XYZ Clinic',
  },
  {
    text: '(practice_services)',
    value:
      '-General Dentistry\n-Endodonics\n-Orthodontics\n-Dental Radiography\n-Oral Surgery',
  },
  { text: '(practice_number)', value: '00-0000-000' },
]

export const PeopleList: PeopleListData[] = [
  { name: 'John Doe' },
  { name: 'Jane Smith' },
  { name: 'Johnathan Davis' },
]

export const TranscriptMockData: TranscriptData[] = [
  {
    speaker: 'Clinic',
    message: 'XYZ Clinic, Sandy speaking. How may I help you?',
    time: '00:00',
  },
  {
    speaker: 'Client',
    message: 'Hi, I’m John Smith. I’d like to inquire about your services.',
    time: '00:05',
  },
  {
    speaker: 'Clinic',
    message: `Sure, Mr. Smith. We offer the following services: 
      General Dentistry, Endodonics, Orthodontics, Dental Radiography, and Oral Surgery.`,
    time: '00:10',
  },
  {
    speaker: 'Client',
    message: 'I’m looking to book a cleaning.',
    time: '00:23',
  },
  {
    speaker: 'Clinic',
    message: 'Great! Would you like to be...to book an appointment',
    time: '00:26',
  },
  { speaker: 'Client', message: 'Yes please.', time: '00:30' },
  {
    speaker: 'Clinic',
    message:
      'I can check our availability. Uhm, are you free on September 3, 2024 at around 3:30PM?',
    time: '00:33',
  },
  { speaker: 'Client', message: 'Yes that works.', time: '00:43' },
  {
    speaker: 'Clinic',
    message: `Perfect! Your appointment is confirmed for the mentioned date. 
      Anything else I can assist you with today?`,
    time: '00:45',
  },
  {
    speaker: 'Client',
    message: 'No, that’s all thank you.',
    time: '00:53',
  },
  {
    speaker: 'Clinic',
    message:
      'You’re welcome. Will look forward to seeing you. Have a great day.',
    time: '00:55',
  },
]

export const AICallSummary: string = `Caller introduced herself as John Smith.
John was inquiring about the clinic’s services.
Requested for an appointment schedule on Tuesday, September 3 2024 at 3:30 PM. `

export const CallLogs: CallsLogData[] = [
  {
    callId: 1,
    id: 'XCP874954',
    type: 'Outgoing',
    date: new Date('October 18, 2024 09:45:00').toISOString(),
    audioSrc: '/audio/1_john_doe.wav',
    duration: '00:06',
    transcript: [
      {
        speaker: 'Clinic',
        message: 'XYZ Clinic, Sandy speaking. How may I help you?',
        time: '00:00',
      },
      {
        speaker: 'Client',
        message: 'Hi, I’m John Smith. I’d like to inquire about your services.',
        time: '00:05',
      },
    ],
    callSummary: [
      'Introduced himself as John Doe',
      'John has an issue raised',
      'Issue has been resolved during the call',
    ],
    sentiments: 'Positive',
    callStatus: 'Resolved',
    firstName: 'John',
    middleName: 'W.',
    lastName: 'Doe',
    dateOfBirth: '1990-01-01',
    address: '123 Main St, Springfield IL',
    gender: 'Male',
    maritalStatus: 'Single',
    profession: 'Engineer',
    companyName: 'Tech Corp',
    mobile: '(555) 123-4567',
    email: 'john.doe@example.com',
    allergies: 'None',
    conditions: 'None',
    insuranceProvider: 'Insurance Inc.',
    policyNumber: 'ABC12345',
    expiryDate: '2025-01-01',
    familyMembers: 'None',
    referralSource: 'Google',
    joinReferralProgram: true,
    preferredAppointmentTimes: '9AM - 11AM',
    contactVia: ['Phone', 'Email'],
    primaryProvider: 'Dr. Smith',
    preferredHygienist: 'N/A',
    notes: '',
    uploadedFiles: [],
    template: '',
    photo: './boy.png',
    status: 'New Patient',
    age: 32,
    dateFirstVisit: '2023-12-01',
    dateLastVisit: '2023-12-01',
    dateFutureVisit: '2024-06-15',
    balanceDue: 0,
    isInsured: true,
    birthdate: '1990-01-01',
    contactNo: '(555) 123-4567',
  },
  {
    callId: 2,
    id: 'ABC837291',
    type: 'Incoming',
    date: new Date('October 17, 2024 08:58:00').toISOString(),
    audioSrc: '/audio/2_na.wav',
    duration: '00:07',
    transcript: [
      {
        speaker: 'Clinic',
        message: 'XYZ Clinic, Sandy speaking. How may I help you?',
        time: '00:00',
      },
      {
        speaker: 'Client',
        message: 'Hi, I’m John Smith. I’d like to inquire about your services.',
        time: '00:05',
      },
    ],
    callSummary: ['Caller was inquiring about the clinic’s services'],
    callNotes: ['This is call notes.'],
    sentiments: 'Neutral',
    callStatus: 'Inquiry',
    firstName: '',
    middleName: '',
    lastName: '',
    dateOfBirth: '',
    address: '',
    gender: '',
    maritalStatus: '',
    profession: '',
    companyName: '',
    mobile: '(555) 123-4567',
    email: '',
    allergies: '',
    conditions: '',
    insuranceProvider: '',
    policyNumber: '',
    expiryDate: '',
    familyMembers: '',
    referralSource: '',
    joinReferralProgram: false,
    preferredAppointmentTimes: '',
    contactVia: [],
    primaryProvider: '',
    preferredHygienist: 'N/A',
    notes: '',
    uploadedFiles: [],
    template: '',
    photo: '',
    status: 'Active',
    age: 0,
    dateFirstVisit: '',
    dateLastVisit: '',
    dateFutureVisit: '',
    balanceDue: 0,
    isInsured: false,
    birthdate: '',
    contactNo: '(555) 123-4567',
  },
  {
    callId: 3,
    id: 'XCP555954',
    type: 'Outgoing',
    date: new Date('October 17, 2024 08:25:00').toISOString(),
    audioSrc: '/audio/3_john_j_emerson.wav',
    duration: '00:08',
    transcript: [
      {
        speaker: 'Clinic',
        message: 'XYZ Clinic, Sandy speaking. How may I help you?',
        time: '00:00',
      },
      {
        speaker: 'Client',
        message: 'Hi, I’m John Smith. I’d like to inquire about your services.',
        time: '00:05',
      },
    ],
    callSummary: [
      'Introduced himself as John Emerson',
      'John was inquiring about the price range of each services provided by the clinic',
    ],
    callNotes: [
      'First call notes is here',
      'Another one note was stated for this call',
    ],
    sentiments: 'Positive',
    callStatus: 'Inquiry',
    firstName: 'Michael',
    middleName: 'B.',
    lastName: 'Johnson',
    dateOfBirth: '1978-07-22',
    address: '789 Maple St, Springfield IL',
    gender: 'Male',
    maritalStatus: 'Divorced',
    profession: 'Accountant',
    companyName: 'Financial Solutions',
    mobile: '(555) 123-4567',
    email: 'michael.johnson@example.com',
    allergies: 'None',
    conditions: 'Hypertension',
    insuranceProvider: 'SecureHealth',
    policyNumber: 'LMN45678',
    expiryDate: '2025-06-30',
    familyMembers: '2 Children',
    referralSource: 'Colleague',
    joinReferralProgram: true,
    preferredAppointmentTimes: '11AM - 1PM',
    contactVia: ['Email'],
    primaryProvider: 'Dr. Green',
    preferredHygienist: 'N/A',
    notes: 'Requires blood pressure monitoring.',
    uploadedFiles: [],
    template: '',
    photo: './boy.png',
    status: 'Active',
    age: 46,
    dateFirstVisit: '2023-10-15',
    dateLastVisit: '2023-10-30',
    dateFutureVisit: '2024-04-20',
    balanceDue: 250,
    isInsured: true,
    birthdate: '1978-07-22',
    contactNo: '(555) 123-4567',
  },
  {
    callId: 4,
    id: 'XCP555954',
    type: 'Missed',
    date: new Date('October 17, 2024 08:20:00').toISOString(),
    callStatus: 'Follow-up required',
    firstName: 'Michael',
    middleName: 'B.',
    lastName: 'Johnson',
    dateOfBirth: '1978-07-22',
    address: '789 Maple St, Springfield IL',
    gender: 'Male',
    maritalStatus: 'Divorced',
    profession: 'Accountant',
    companyName: 'Financial Solutions',
    mobile: '(555) 123-4567',
    email: 'michael.johnson@example.com',
    allergies: 'None',
    conditions: 'Hypertension',
    insuranceProvider: 'SecureHealth',
    policyNumber: 'LMN45678',
    expiryDate: '2025-06-30',
    familyMembers: '2 Children',
    referralSource: 'Colleague',
    joinReferralProgram: true,
    preferredAppointmentTimes: '11AM - 1PM',
    contactVia: ['Email'],
    primaryProvider: 'Dr. Green',
    preferredHygienist: 'N/A',
    notes: 'Requires blood pressure monitoring.',
    uploadedFiles: [],
    template: '',
    photo: './boy.png',
    status: 'Active',
    age: 46,
    dateFirstVisit: '2023-10-15',
    dateLastVisit: '2023-10-30',
    dateFutureVisit: '2024-04-20',
    balanceDue: 250,
    isInsured: true,
    birthdate: '1978-07-22',
    contactNo: '(555) 123-4567',
  },
  {
    callId: 5,
    id: 'XCP224954',
    type: 'Outgoing',
    date: new Date('October 16, 2024 14:16:00').toISOString(),
    audioSrc: '/audio/5_john_t_snow.wav',
    duration: '00:10',
    transcript: [
      {
        speaker: 'Clinic',
        message: 'XYZ Clinic, Sandy speaking. How may I help you?',
        time: '00:00',
      },
      {
        speaker: 'Client',
        message: 'Hi, I’m John Smith. I’d like to inquire about your services.',
        time: '00:05',
      },
    ],
    callSummary: [
      'Introduced himself as John Snow',
      'John was inquiring about the price range of each services provided by the clinic',
      'Clinic was not able to provide the information asked by John.',
    ],
    sentiments: 'Negative',
    callStatus: 'Inquiry',
    firstName: 'Jane',
    middleName: 'A.',
    lastName: 'Smith',
    dateOfBirth: '1985-03-15',
    address: '456 Elm St, Springfield IL',
    gender: 'Female',
    maritalStatus: 'Married',
    profession: 'Teacher',
    companyName: 'Springfield High',
    mobile: '(555) 123-4567',
    email: 'jane.smith@example.com',
    allergies: 'Peanuts',
    conditions: 'Asthma',
    insuranceProvider: 'HealthFirst',
    policyNumber: 'XYZ67890',
    expiryDate: '2024-10-20',
    familyMembers: 'Husband, 2 Children',
    referralSource: 'Friend',
    joinReferralProgram: false,
    preferredAppointmentTimes: '2PM - 4PM',
    contactVia: ['Phone'],
    primaryProvider: 'Dr. Brown',
    preferredHygienist: 'N/A',
    notes: 'Prefers afternoon appointments.',
    uploadedFiles: [],
    template: '',
    photo: './girl.png',
    status: 'Active',
    age: 39,
    dateFirstVisit: '2023-11-05',
    dateLastVisit: '2023-11-20',
    dateFutureVisit: '2024-05-10',
    balanceDue: 100,
    isInsured: true,
    birthdate: '1985-03-15',
    contactNo: '(555) 123-4567',
  },
  {
    callId: 6,
    id: 'XCP777954',
    type: 'Decline',
    date: new Date('October 16, 2024 14:16:00').toISOString(),
    callStatus: 'Follow-up required',
    firstName: 'Emily',
    middleName: 'C.',
    lastName: 'Davis',
    dateOfBirth: '1992-05-12',
    address: '321 Oak St, Springfield IL',
    gender: 'Female',
    maritalStatus: 'Single',
    profession: 'Software Developer',
    companyName: 'Tech Innovators',
    mobile: '(555) 123-4567',
    email: 'emily.davis@example.com',
    allergies: 'None',
    conditions: 'Diabetes',
    insuranceProvider: 'HealthPlus',
    policyNumber: 'DEF12345',
    expiryDate: '2024-12-31',
    familyMembers: 'None',
    referralSource: 'Social Media',
    joinReferralProgram: true,
    preferredAppointmentTimes: '1PM - 3PM',
    contactVia: ['SMS', 'App'],
    primaryProvider: 'Dr. White',
    preferredHygienist: 'N/A',
    notes: 'Prefers digital communication.',
    uploadedFiles: [],
    template: '',
    photo: './girl.png',
    status: 'New Patient',
    age: 32,
    dateFirstVisit: '2023-09-10',
    dateLastVisit: 'N/A',
    dateFutureVisit: '2024-03-25',
    balanceDue: 0,
    isInsured: true,
    birthdate: '1992-05-12',
    contactNo: '(555) 123-4567',
  },
  {
    callId: 7,
    id: 'XCP777954',
    type: 'Incoming',
    date: new Date('June 28, 2024 16:48:00').toISOString(),
    audioSrc: '/audio/7_johna_smith.wav',
    duration: '00:08',
    transcript: [
      {
        speaker: 'Clinic',
        message: 'XYZ Clinic, Sandy speaking. How may I help you?',
        time: '00:00',
      },
      {
        speaker: 'Client',
        message: 'Hi, I’m John Smith. I’d like to inquire about your services.',
        time: '00:05',
      },
    ],
    callSummary: [
      'Introduced herself as Johna Smith',
      'John raised an issue about his recent visit',
      'The issue was not resolved during the call',
    ],
    callNotes: [
      'This is a negative call',
      'There is still issue need to be resolved',
      'This is high priority',
    ],
    sentiments: 'Negative',
    callStatus: 'Unresolved',
    firstName: 'Emily',
    middleName: 'C.',
    lastName: 'Davis',
    dateOfBirth: '1992-05-12',
    address: '321 Oak St, Springfield IL',
    gender: 'Female',
    maritalStatus: 'Single',
    profession: 'Software Developer',
    companyName: 'Tech Innovators',
    mobile: '(555) 123-4567',
    email: 'emily.davis@example.com',
    allergies: 'None',
    conditions: 'Diabetes',
    insuranceProvider: 'HealthPlus',
    policyNumber: 'DEF12345',
    expiryDate: '2024-12-31',
    familyMembers: 'None',
    referralSource: 'Social Media',
    joinReferralProgram: true,
    preferredAppointmentTimes: '1PM - 3PM',
    contactVia: ['SMS', 'App'],
    primaryProvider: 'Dr. White',
    preferredHygienist: 'N/A',
    notes: 'Prefers digital communication.',
    uploadedFiles: [],
    template: '',
    photo: './girl.png',
    status: 'New Patient',
    age: 32,
    dateFirstVisit: '2023-09-10',
    dateLastVisit: 'N/A',
    dateFutureVisit: '2024-03-25',
    balanceDue: 0,
    isInsured: true,
    birthdate: '1992-05-12',
    contactNo: '(555) 123-4567',
  },
  {
    callId: 8,
    id: 'XCP777954',
    type: 'Missed',
    date: new Date('June 28, 2024 16:24:00').toISOString(),
    callStatus: 'Follow-up required',
    firstName: 'Emily',
    middleName: 'C.',
    lastName: 'Davis',
    dateOfBirth: '1992-05-12',
    address: '321 Oak St, Springfield IL',
    gender: 'Female',
    maritalStatus: 'Single',
    profession: 'Software Developer',
    companyName: 'Tech Innovators',
    mobile: '(555) 123-4567',
    email: 'emily.davis@example.com',
    allergies: 'None',
    conditions: 'Diabetes',
    insuranceProvider: 'HealthPlus',
    policyNumber: 'DEF12345',
    expiryDate: '2024-12-31',
    familyMembers: 'None',
    referralSource: 'Social Media',
    joinReferralProgram: true,
    preferredAppointmentTimes: '1PM - 3PM',
    contactVia: ['SMS', 'App'],
    primaryProvider: 'Dr. White',
    preferredHygienist: 'N/A',
    notes: 'Prefers digital communication.',
    uploadedFiles: [],
    template: '',
    photo: './girl.png',
    status: 'New Patient',
    age: 32,
    dateFirstVisit: '2023-09-10',
    dateLastVisit: 'N/A',
    dateFutureVisit: '2024-03-25',
    balanceDue: 0,
    isInsured: true,
    birthdate: '1992-05-12',
    contactNo: '(555) 123-4567',
  },
  {
    callId: 9,
    id: 'XCP111954',
    type: 'Decline',
    date: new Date('June 28, 2024 15:37:00').toISOString(),
    callStatus: 'Unresolved',
    firstName: 'Robert',
    middleName: 'D.',
    lastName: 'Miller',
    dateOfBirth: '1982-12-03',
    address: '654 Pine St, Springfield IL',
    gender: 'Male',
    maritalStatus: 'Married',
    profession: 'Construction Manager',
    companyName: 'BuildRight',
    mobile: '(555) 123-4567',
    email: 'robert.miller@example.com',
    allergies: 'Dust',
    conditions: 'Arthritis',
    insuranceProvider: 'MediCover',
    policyNumber: 'GHI67890',
    expiryDate: '2025-08-15',
    familyMembers: 'Wife, 3 Children',
    referralSource: 'Google',
    joinReferralProgram: false,
    preferredAppointmentTimes: '10AM - 12PM',
    contactVia: ['Phone', 'Email'],
    primaryProvider: 'Dr. Blue',
    preferredHygienist: 'N/A',
    notes: 'Prefers morning appointments.',
    uploadedFiles: [],
    template: '',
    photo: './boy.png',
    status: 'Active',
    age: 41,
    dateFirstVisit: '2023-08-20',
    dateLastVisit: '2023-09-05',
    dateFutureVisit: '2024-02-15',
    balanceDue: 50,
    isInsured: true,
    birthdate: '1982-12-03',
    contactNo: '(555) 123-4567',
  },
  {
    callId: 10,
    id: 'XCP111954',
    type: 'Incoming',
    date: new Date('June 28, 2024 15:37:00').toISOString(),
    audioSrc: '/audio/10_john_doe.wav',
    duration: '00:06',
    transcript: [
      {
        speaker: 'Clinic',
        message: 'XYZ Clinic, Sandy speaking. How may I help you?',
        time: '00:00',
      },
      {
        speaker: 'Client',
        message: 'Hi, I’m John Smith. I’d like to inquire about your services.',
        time: '00:05',
      },
    ],
    callSummary: [
      'Introduced himself as John Doe',
      'John was raising a suggestion that would help the clinic on providing better service',
    ],
    sentiments: 'Neutral',
    callStatus: 'High priority',
    firstName: 'Robert',
    middleName: 'D.',
    lastName: 'Miller',
    dateOfBirth: '1982-12-03',
    address: '654 Pine St, Springfield IL',
    gender: 'Male',
    maritalStatus: 'Married',
    profession: 'Construction Manager',
    companyName: 'BuildRight',
    mobile: '(555) 123-4567',
    email: 'robert.miller@example.com',
    allergies: 'Dust',
    conditions: 'Arthritis',
    insuranceProvider: 'MediCover',
    policyNumber: 'GHI67890',
    expiryDate: '2025-08-15',
    familyMembers: 'Wife, 3 Children',
    referralSource: 'Google',
    joinReferralProgram: false,
    preferredAppointmentTimes: '10AM - 12PM',
    contactVia: ['Phone', 'Email'],
    primaryProvider: 'Dr. Blue',
    preferredHygienist: 'N/A',
    notes: 'Prefers morning appointments.',
    uploadedFiles: [],
    template: '',
    photo: './boy.png',
    status: 'Active',
    age: 41,
    dateFirstVisit: '2023-08-20',
    dateLastVisit: '2023-09-05',
    dateFutureVisit: '2024-02-15',
    balanceDue: 50,
    isInsured: true,
    birthdate: '1982-12-03',
    contactNo: '(555) 123-4567',
  },
  {
    callId: 11,
    id: 'STU583721',
    type: 'Incoming',
    date: new Date('June 28, 2024 12:48:00').toISOString(),
    audioSrc: '/audio/11_john_doe.wav',
    duration: '00:09',
    transcript: [
      {
        speaker: 'Clinic',
        message: 'XYZ Clinic, Sandy speaking. How may I help you?',
        time: '00:00',
      },
      {
        speaker: 'Client',
        message: 'Hi, I’m John Smith. I’d like to inquire about your services.',
        time: '00:05',
      },
    ],
    callSummary: [
      'Introduced himself as John Doe',
      'John was inquiring about the price range of each services provided by the clinic',
    ],
    sentiments: 'Positive',
    callStatus: 'Inquiry',
    firstName: '',
    middleName: '',
    lastName: '',
    dateOfBirth: '',
    address: '',
    gender: '',
    maritalStatus: '',
    profession: '',
    companyName: '',
    mobile: '(555) 123-4567',
    email: '',
    allergies: '',
    conditions: '',
    insuranceProvider: '',
    policyNumber: '',
    expiryDate: '',
    familyMembers: '',
    referralSource: '',
    joinReferralProgram: false,
    preferredAppointmentTimes: '',
    contactVia: [],
    primaryProvider: '',
    preferredHygienist: 'N/A',
    notes: '',
    uploadedFiles: [],
    template: '',
    photo: '',
    status: 'Active',
    age: 0,
    dateFirstVisit: '',
    dateLastVisit: '',
    dateFutureVisit: '',
    balanceDue: 0,
    isInsured: false,
    birthdate: '',
    contactNo: '+1 (315) 369-3197',
  },
  {
    callId: 12,
    id: 'XCP874954',
    type: 'Incoming',
    date: new Date('June 28, 2024 08:58:00').toISOString(),
    audioSrc: '/audio/12_paul_doe.wav',
    duration: '00:09',
    transcript: [
      {
        speaker: 'Clinic',
        message: 'XYZ Clinic, Sandy speaking. How may I help you?',
        time: '00:00',
      },
      {
        speaker: 'Client',
        message: 'Hi, I’m John Smith. I’d like to inquire about your services.',
        time: '00:05',
      },
    ],
    callSummary: [
      'Introduced himself as Paul Doe',
      'Paul provided a positive feedback and suggestions',
    ],
    sentiments: 'Positive',
    callStatus: 'High priority',
    firstName: 'John',
    middleName: 'W.',
    lastName: 'Doe',
    dateOfBirth: '1990-01-01',
    address: '123 Main St, Springfield IL',
    gender: 'Male',
    maritalStatus: 'Single',
    profession: 'Engineer',
    companyName: 'Tech Corp',
    mobile: '(555) 123-4567',
    email: 'john.doe@example.com',
    allergies: 'None',
    conditions: 'None',
    insuranceProvider: 'Insurance Inc.',
    policyNumber: 'ABC12345',
    expiryDate: '2025-01-01',
    familyMembers: 'None',
    referralSource: 'Google',
    joinReferralProgram: true,
    preferredAppointmentTimes: '9AM - 11AM',
    contactVia: ['Phone', 'Email'],
    primaryProvider: 'Dr. Smith',
    preferredHygienist: 'N/A',
    notes: '',
    uploadedFiles: [],
    template: '',
    photo: './boy.png',
    status: 'New Patient',
    age: 32,
    dateFirstVisit: '2023-12-01',
    dateLastVisit: '2023-12-01',
    dateFutureVisit: '2024-06-15',
    balanceDue: 0,
    isInsured: true,
    birthdate: '1990-01-01',
    contactNo: '(555) 123-4567',
  },
  {
    callId: 13,
    id: 'XCP874954',
    type: 'Missed',
    date: new Date('June 28, 2023 08:27:00').toISOString(),
    callStatus: 'Follow-up required',
    firstName: 'John',
    middleName: 'W.',
    lastName: 'Doe',
    dateOfBirth: '1990-01-01',
    address: '123 Main St, Springfield IL',
    gender: 'Male',
    maritalStatus: 'Single',
    profession: 'Engineer',
    companyName: 'Tech Corp',
    mobile: '(555) 123-4567',
    email: 'john.doe@example.com',
    allergies: 'None',
    conditions: 'None',
    insuranceProvider: 'Insurance Inc.',
    policyNumber: 'ABC12345',
    expiryDate: '2025-01-01',
    familyMembers: 'None',
    referralSource: 'Google',
    joinReferralProgram: true,
    preferredAppointmentTimes: '9AM - 11AM',
    contactVia: ['Phone', 'Email'],
    primaryProvider: 'Dr. Smith',
    preferredHygienist: 'N/A',
    notes: '',
    uploadedFiles: [],
    template: '',
    photo: './boy.png',
    status: 'New Patient',
    age: 32,
    dateFirstVisit: '2023-12-01',
    dateLastVisit: '2023-12-01',
    dateFutureVisit: '2024-06-15',
    balanceDue: 0,
    isInsured: true,
    birthdate: '1990-01-01',
    contactNo: '(555) 123-4567',
  },
]

export const FaxInboxList: FaxMessage[] = [
  {
    name: 'John Doe',
    faxNumber: '+1-555-1111',
    subject: 'Request for Appointment Confirmation',
    message: `Hello, I would like to confirm my appointment scheduled for next Tuesday. 
      Please let me know if any documents are required beforehand.`,
    timestamp: new Date('2024-11-01T09:30:00').toISOString(),
  },
  {
    name: 'Dental Lounge',
    faxNumber: '+1-555-2222',
    subject: 'Referral for Specialist Consultation',
    message: `We are referring a patient to your clinic for a specialist consultation. 
      Attached are the preliminary test results and relevant records.`,
    timestamp: new Date('2024-11-01T11:15:00').toISOString(),
  },
  {
    name: 'Steve Jones',
    faxNumber: '+1-555-3333',
    subject: 'Billing Inquiry',
    message: `I have a question regarding my latest bill. 
      Could you please clarify the charges listed under "additional procedures"?`,
    timestamp: new Date('2024-11-01T14:00:00').toISOString(),
  },
  {
    name: 'Testing Fax',
    faxNumber: '+1-555-4444',
    subject: 'Test Fax Transmission',
    message: `This is a test fax to verify that the transmission 
      service is working correctly. Please confirm receipt.`,
    timestamp: new Date('2024-11-01T16:45:00').toISOString(),
  },
  {
    name: 'Jane Smith',
    faxNumber: '+1-555-5555',
    subject: 'Follow-up on Recent Appointment',
    message: `Thank you for the recent treatment. I have some follow-up 
      questions regarding post-procedure care. Please let me know the best time to discuss.`,
    timestamp: new Date('2024-11-01T18:30:00').toISOString(),
  },
]

export const FaxSentList: FaxMessage[] = [
  {
    name: 'Dental Health Center',
    faxNumber: '+1-555-1234',
    subject: 'Patient Appointment Details',
    message: `Patient records for upcoming appointment. Please review the 
      attached details for the scheduled procedure on Monday.`,
    timestamp: new Date('2024-10-30T10:15:00').toISOString(),
  },
  {
    name: 'Testing Fax',
    faxNumber: '+1-555-5678',
    subject: 'Insurance Verification',
    message: `Insurance verification request for patient John Doe. 
      Kindly confirm the coverage details for the scheduled treatment.`,
    timestamp: new Date('2024-10-31T14:30:00').toISOString(),
  },
  {
    name: 'Ortho Specialists',
    faxNumber: '+1-555-9876',
    subject: 'Referral Letter for Orthodontic Consultation',
    message: `Referral letter for orthodontic consultation. 
      The patient requires an evaluation for braces, as discussed with Dr. Smith.`,
    timestamp: new Date('2024-11-01T09:00:00').toISOString(),
  },
  {
    name: 'Clinic Administration',
    faxNumber: '+1-555-4321',
    subject: 'Monthly Supply Order Confirmation',
    message: `Monthly supply order confirmation. Please verify the quantities 
      of dental materials ordered and confirm the shipping details.`,
    timestamp: new Date('2024-11-01T16:45:00').toISOString(),
  },
  {
    name: 'Testing Fax',
    faxNumber: '+1-555-5678',
    subject: 'Follow-up Notes',
    message: `Follow-up notes from the previous consultation with Jane Doe. 
      Attached are the X-rays and recommended treatment plan.`,
    timestamp: new Date('2024-11-02T11:30:00').toISOString(),
  },
]

export const FaxDraftList: FaxMessage[] = [
  {
    name: 'Dental Supplies Co.',
    faxNumber: '+1-555-6789',
    subject: 'Order Inquiry for Dental Materials',
    message: `Draft for confirming the order details of dental materials for 
    next month. Please verify the quantities and shipping address before sending.`,
    timestamp: new Date('2024-11-02T10:00:00').toISOString(),
  },
]

export const FaxArchiveList: FaxMessage[] = [
  {
    name: 'Dental Health Center',
    faxNumber: '+1-555-1234',
    subject: 'End-of-Year Report',
    message: `End-of-year report for patient appointments and procedures. 
      This document summarizes clinic activity for the last fiscal year.`,
    timestamp: new Date('2023-12-20T08:30:00').toISOString(),
  },
  {
    name: 'Dental Lab Services',
    faxNumber: '+1-555-8765',
    subject: 'Lab Results for Dental Implants',
    message: `Lab results for recent dental implants. 
      Please archive this for reference in future follow-up appointments with the patient.`,
    timestamp: new Date('2024-01-15T15:00:00').toISOString(),
  },
]

export const FaxDeletedList: FaxMessage[] = [
  {
    name: 'Dental Health Center',
    faxNumber: '+1-555-1234',
    subject: 'Erroneous Appointment Reminder',
    message: `Appointment reminder that was sent in error. 
      This message is no longer valid and should be disregarded.`,
    timestamp: new Date('2024-10-29T13:00:00').toISOString(),
  },
]
